import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { useState } from "react";
import DataGridScrapingDetails from "src/components/data-grid/activations/data-grid-scraping-details";

export default function ModalScraping({
    open,
    rowsToDisplay,
    onClose,
    onConfirm,
    setScrapingDetails,
}: {
    open: boolean;
    rowsToDisplay: any[];
    onClose: () => void;
    onConfirm: (rowsToDelete: Set<any>) => void;
    setScrapingDetails: any;
}) {
    const [rowsToDelete, setRowsToDelete]: any = useState<Set<any>>(new Set());

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>Add scraping</DialogTitle>

            <DialogContent>
                <Box mt={1}>
                    <DataGridScrapingDetails
                        rows={rowsToDisplay}
                        onChange={(updatedRows, rowsToDeleteFromChild) => {
                            setScrapingDetails(updatedRows);
                            setRowsToDelete(rowsToDeleteFromChild ?? new Set());
                        }}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={() => onConfirm(rowsToDelete)}
                    variant="contained"
                >
                    {"Validate"}
                </Button>


                <Button
                    onClick={onClose}
                    variant="outlined"
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}
